/* Receptionist role */
const receptionist = () => 'receptionist';

/* Manager role */
const manager = () => 'manager';

/* Master role */
const master = () => 'master';

const Roles = {
    receptionist,
    manager,
    master,
};

export default Roles;
